import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Flex } from "@redotech/arbiter/flex";
import { useTranslation } from "@redotech/redo-i18n";
import { memo } from "react";

export const InStorePackingSlipButton = memo(function InStorePackingSlipButton({
  packingSlipLink,
  onOpenUrl,
}: {
  packingSlipLink: string | undefined;
  onOpenUrl: (url: string) => void;
}) {
  const { t } = useTranslation();
  if (!packingSlipLink) {
    return null;
  }

  return (
    <Flex>
      <RedoButton
        hierarchy="secondary"
        onClick={() => onOpenUrl(packingSlipLink)}
        text={t("Print return authorization")}
      />
    </Flex>
  );
});
